'use client';

import React from 'react';
import Link from 'next/link';

const NeedForCentre = () => {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            The Need for a Centre
          </h2>

          <div className="space-y-8 text-lg text-gray-800 font-body leading-relaxed">
            <p>
              AI will reshape every organisation and institution over the coming decade. The organisations and institutions that succeed will be those that treat change as a continuous capability — not a series of discrete projects.
            </p>
            <p>
              AI Change Leadership describes how this capability is led, governed, and sustained. It provides the language, frameworks, and standards that enable boards, executive teams, and practitioners to navigate continuous transformation with clarity and confidence.
            </p>
            <p>
              This discipline requires a clear centre — an independent authority that defines standards, articulates principles, and advances shared understanding across industries and sectors.
            </p>
            <p className="text-xl font-semibold text-[#0A2540]">
              AI Change Leaders exists to provide that centre.
            </p>
          </div>

          <div className="mt-16 pt-12 border-t-2 border-gray-200">
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link
                href="/homepage"
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-[#0A2540] text-[#0A2540] font-semibold text-lg rounded-none hover:bg-[#0A2540] hover:text-white transition-all duration-300"
              >
                Return to Homepage
              </Link>
              <Link
                href="/homepage#system"
                className="inline-flex items-center justify-center px-8 py-4 bg-[#0A2540] text-white font-semibold text-lg rounded-none hover:bg-[#0A2540]/90 transition-all duration-300"
              >
                Explore The AI Change Leadership System™
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NeedForCentre;